module.exports = __webpack_public_path__ + "img/bg_x2.61060d33.jpg";